<template lang="html">

    <div class="wrapper margin-menu -area-personal column-center">

        <div class="contenedor-formulario">

            <h1 class="title-intro">Editar suscripción</h1>

            <div class="payment-container">

                <h4>Cuanto quieres donar</h4>

                <div class="contenedor-input -radios row-center">
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="20"
                            id="amount-20">
                        <label for="amount-20"><strong>20</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="25"
                            id="amount-25">
                        <label for="amount-25"><strong>25</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="50"
                            id="amount-50">
                        <label for="amount-50"><strong>50</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="100"
                            id="amount-100">
                        <label for="amount-100"><strong>100</strong> Euros</label>
                    </div>

                    <div class="contenedor-input">
                        <label for="otheramount">Indicar otra cantidad</label>
                        <input @change="setOtherAmount" type="text" name="amount" id="otheramount"
                            v-model="data.otheramount">
                    </div>

                    <span v-if="erroramount" class="error">Por favor, selecciona un importe para donar</span>
                </div>

                <!-- <h4>¿Cada cuanto tiempo?</h4>

                <div class="contenedor-input row-center">

                    <div class="radio-el">
                        <input type="radio" name="time" v-model="data.time" :value="'1'" id="time-tarjeta"
                            v-validate="'required'">
                        <label for="time-tarjeta">Mensual</label>
                    </div>

                    <div class="radio-el">
                        <input type="radio" name="time" v-model="data.time" :value="'2'" id="time-transferencia"
                            v-validate="'required'">
                        <label for="time-transferencia">Anual</label>
                    </div>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('time')
                        }}</span>

                </div> -->

                <div class="contenedor-boton row-center">
                    <button @click="validateBeforeSubmit" class="btn red" :loading="loading">Modificar
                        donación</button>
                </div>

            </div>



        </div>

    </div>

</template>


<script>

    import { mapActions } from 'vuex';

    import router from '@/router';

    export default {
        name: 'crear-suscripcion',
        mounted() {



            setTimeout(() => {
                this.getSubscriptions().then(r => {
                    this.suscriptions = r;

                    let amount = Number(this.suscriptions[0].amount);
                    let values = [20,25,50,100];

                    if(values.some(v => v === amount)){
                        this.data.amount = amount; 
                    }else{
                        this.data.otheramount = this.suscriptions[0].amount; 
                    }


                });
            }, 200);

        },
        data() {
            return {
                data: {
                    amount: '',
                    otheramount: '',
                    time: 0
                },
                loading: false,
                erroramount: false,
                clicked: false,
                suscriptions: '',
                errormessage: '',
                user : ''
            }
        },
        methods: {
            ...mapActions(['editSubscription','getSubscriptions']),
            validateBeforeSubmit() {

                this.erroramount = (!!!this.data.amount);

                this.$validator.validateAll().then(canSend => {
                    this.loading = true;
                    if (canSend && !this.erroramount) {
                        this.requestsuscripcion();
                    }
                });
            },
            requestsuscripcion() {
                this.editSubscription(this.data).then(r => {
                    if (r) {
                        router.push({ name: 'areainterna' });
                        this.loading = false;
                    }
                });
            },
            setOtherAmount() {
                if (!!this.data.otheramount) {
                    this.data.amount = this.data.otheramount.replace(/\,/g, '.');
                }
            },
            eraseOtherAmount() {
                if (!!this.data.amount) {
                    this.data.otheramount = '';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/modificar-suscripcion.vue